import {_} from "../../Lang.class.js";
import Checkbox from "../Checkbox/Checkbox";
import type {FilterSubMenuValue} from "../../types-analytics";

interface ModalColorizerSetupHeaderCallbacks {
    onChangeUseFilter: (useFilter: boolean) => void;
    onChangeSelect: (selectedOption: string, resetSliderUserPeriods: boolean) => void;
}

export interface ColorizeCategories {
    [key: string]: {
        id: string,
        label: string,
    }[];
}

export class ModalColorizerSetupHeader {

    public element: HTMLDivElement;
    private callbacks: ModalColorizerSetupHeaderCallbacks;
    private selectedOption: string = '';
    private useFilter: boolean = false; // FIXME: Get this settings from memory
    private readonly categories: ColorizeCategories;
    private checkboxUseFilter: any;
    private readonly subMenuConfig: {[key:string]: FilterSubMenuValue};

    constructor(
        categories: ColorizeCategories,
        selectedOption: string,
        subMenuConfig: {[key:string]: FilterSubMenuValue},
        callbacks: ModalColorizerSetupHeaderCallbacks
    ) {
        this.callbacks = callbacks;
        this.selectedOption = selectedOption;
        this.categories = categories;
        this.subMenuConfig = subMenuConfig;
        this.init();
    }

    setUseFilterCheckboxEnabled(enabled: boolean) {
        this.checkboxUseFilter.setEnabled(enabled);
    }
    
    private getClusterIdFromGivenItemId(itemId: string): string {
        let output: string = '';
        Object.keys(this.subMenuConfig).forEach((clusterId: string) => {
            if (this.subMenuConfig[clusterId].items.map( item => item.id).includes(itemId)) {
                output = clusterId;
                return;
            }
        });
        return output;
    }

    getOptions(): string {
        let html = '';
        let labels_used = [];
        // console.log('ModalColorizerSetupHeader, getOptions', this.categories, this.selectedOption);
        for (let optgroup in this.categories) {
            let optgroup_locale = _(optgroup)[0].toUpperCase() + _(optgroup).slice(1);
            html += `<optgroup label="${optgroup_locale}">`;
            for (let option of this.categories[optgroup]) {
                let label : string = option.label;
                let selected: boolean = this.selectedOption == option.id;
                let clusterId: string = this.getClusterIdFromGivenItemId(option.id);
                let selectedClusterId: string = this.getClusterIdFromGivenItemId(this.selectedOption);
                let addOption: boolean = false;
            
                // If there is a clusterId, then use the cluster label
                if (clusterId!== '') {
                    label = `${_(this.subMenuConfig[clusterId].label)}`;
                }
                
                addOption = (selectedClusterId=='' || clusterId!==selectedClusterId || selected) && !labels_used.includes(label);
               
                if (addOption) {
                    html += `<option value="${option.id}" ${(selected ? 'selected' : '')}>${label}</option>`;
                    labels_used.push(label);
                }
                
            }
            html += `</optgroup>`;
        }
        return html;
    }

    init() {
        this.element = document.createElement('div');
        this.reload(this.selectedOption, this.useFilter);
    }
    
    changeSelectedOption(newSelectedOption: string, resetSliderUserPeriods) {
        this.selectedOption = newSelectedOption;
        // this.reload(this.selectedOption, this.useFilter);
        this.callbacks.onChangeSelect(newSelectedOption, resetSliderUserPeriods);
    }

    reload(selectedOption: string, useFilter: boolean) {

        this.selectedOption = selectedOption ?? this.selectedOption;
        this.useFilter = useFilter ?? this.useFilter;

        if (this.element) {
            this.element.innerHTML = this.getHTML();

            let selectedOptionSelect = this.element.querySelector('#colorize_fld_name') as HTMLSelectElement;
            if (selectedOptionSelect) {
                selectedOptionSelect.addEventListener('change', (e) => {
                    let newSelectedOption = (e.target as HTMLSelectElement).value;
                    console.log('ModalColorizerSetupHeader, change', newSelectedOption);
                    this.callbacks.onChangeSelect(newSelectedOption, true);
                });
            }

            this.checkboxUseFilter = Checkbox(
                {
                    checked: this.useFilter,
                    label: 'Uwzględniaj filtr',
                    mode: 'white-checkbox',
                    disabled: false
                },
                {
                    onChange: (useFilter: boolean) => {
                        this.useFilter = useFilter;
                        this.callbacks.onChangeUseFilter(this.useFilter);
                    }
                }
            )
            this.element.querySelector('.js-use-filter').appendChild( this.checkboxUseFilter.element );
        }

    }

    getElement() {
        return this.element;
    }

    getHTML() {
        return `
        <div class="telematics-colorize_header">
            <div class="header_checkbox">
                <div style="font-weight: 500; font-size: 14px;">
                    Atrybuty kolorowania
                </div>
                <div class="js-use-filter"></div>
            </div>
            <div class="header_select">
                <select id="colorize_fld_name">
                ` + this.getOptions() + `
                </select>
                <div class="max_color_blocks_info text_small text_white" style="text-align: center; margin-top: 3px; opacity: 0.7;">Max 6 przedziałów</div>
            </div>
        </div>
            `;
    }

}

// export default ModalColorizerSetupHeader;